import includes from "lodash/includes"
import get from "lodash/get"
import {
  PLANS_URL,
  PLAN_TYPES_URL,
  EVENT_TYPES_URL,
  EVENTS_URL,
  RESOURCES_URL,
  RESOURCE_TYPES_URL,
  REPORT_TEMPLATES_URL,
  CALENDAR_URL,
  ROLES_URL,
} from "src/constants/routeNames"
import planModel from "src/models/plan"
import planTypeModel from "src/models/planType"
import eventModel from "src/models/event"
import resourceTypeModel from "src/models/resourceType"
import selectData from "src/engine/modules/entity/selectors/data"
import moment from "moment"

const NEW = `new`

export const getDate = date => moment(date).format(`DD.MM.YYYY`)

const calendarCrumbs = (pathParts, setBreadcrumbs, topBarState) => {
  const BASIC_CRUMB = `КАЛЕНДАРЬ`
  // pathParts[0] -> calendar
  // pathParts[1] -> scale
  // pathParts[2] -> date
  // pathParts[3] -> events
  // pathParts[4] -> eventId

  const eventName = get(topBarState, `eventName`)
  const inModalButNoData = Object.keys(topBarState).length > 0 && !eventName
  let crumbs = inModalButNoData
    ? []
    : [
        {
          name: BASIC_CRUMB,
        },
      ]

  if (includes(pathParts, EVENTS_URL.replace(`/`, ``))) {
    const isNew = pathParts[4] === NEW
    if (isNew) {
      crumbs = [
        {
          name: BASIC_CRUMB,
          to: `/${pathParts[0]}/${pathParts[1]}/${pathParts[2]}`,
        },
        {
          name: `${pathParts[2]} - НОВОЕ СОБЫТИЕ`,
        },
      ]
    } else if (eventName) {
      crumbs = [
        {
          name: BASIC_CRUMB,
          to: `/${pathParts[0]}/`,
        },
        {
          name: `${get(topBarState, `eventDate`)} ${get(
            topBarState,
            `eventName`,
          )}`,
        },
      ]
    }
  }

  setBreadcrumbs(crumbs)
}
const plansCrumbs = (
  pathParts,
  setBreadcrumbs,
  topBarState,
  planEventCaseName,
) => {
  const BASIC_CRUMB = `ПЛАНЫ`
  // pathParts[0] -> plans
  // pathParts[1] -> planId
  // pathParts[2] -> calendar
  // pathParts[3] -> scale
  // pathParts[4] -> date
  // pathParts[5] -> settings OR events
  // pathParts[6] -> eventId

  const planName = get(topBarState, `planName`)
  const inModalButNoData = Object.keys(topBarState).length > 0 && !planName
  let crumbs = inModalButNoData
    ? []
    : [
        {
          name: BASIC_CRUMB,
        },
      ]

  if (includes(pathParts, `calendar`) && planName) {
    if (includes(pathParts, `settings`)) {
      crumbs = [
        {
          name: BASIC_CRUMB,
          to: `/${pathParts[0]}`,
        },
        {
          name: `${get(topBarState, `planDate`)} ${planName}`,
          to: `/${pathParts[0]}/${pathParts[1]}/calendar/`,
        },
        { name: `НАСТРОЙКИ ПЛАНА` },
      ]
    }
    if (includes(pathParts, `planEvents`)) {
      crumbs = [
        {
          name: BASIC_CRUMB,
          to: `/${pathParts[0]}`,
        },
        {
          name: `${get(topBarState, `planDate`)} ${planName}`,
          to: `/${pathParts[0]}/${pathParts[1]}/calendar/`,
        },
        { name: `События` },
      ]
    } else if (includes(pathParts, EVENTS_URL.replace(`/`, ``)) && planName) {
      if (pathParts[6] === NEW) {
        crumbs = [
          {
            name: BASIC_CRUMB,
            to: `/${pathParts[0]}`,
          },
          {
            name: `${get(topBarState, `planDate`)} ${get(
              topBarState,
              `planName`,
            )}`,
            to: `/${pathParts[0]}/${pathParts[1]}/calendar`,
          },
          { name: `НОВОЕ СОБЫТИЕ` },
        ]
      }
      if (pathParts[6] !== NEW && planName) {
        crumbs = [
          {
            name: BASIC_CRUMB,
            to: `/${pathParts[0]}`,
          },
          {
            name: `${get(planEventCaseName, `planDate`) ||
              get(topBarState, `planDate`)} - ${get(
              planEventCaseName,
              `planName`,
            ) || get(topBarState, `planName`)}`,
            to: `/${pathParts[0]}/${pathParts[1]}/calendar/`,
          },
          {
            name: `${get(topBarState, `eventDate`)} ${get(
              topBarState,
              `eventName`,
            )}`,
          },
        ]
      }
    } else if (planName) {
      crumbs = [
        {
          name: BASIC_CRUMB,
          to: `/${pathParts[0]}`,
        },
        {
          name: `${get(topBarState, `planDate`)} ${get(
            topBarState,
            `planName`,
          )}`,
        },
      ]
    }
  } else if (pathParts[1] === NEW) {
    crumbs = [
      {
        name: BASIC_CRUMB,
        to: `/${pathParts[0]}`,
      },
      {
        name: `НОВЫЙ ПЛАН`,
      },
    ]
  } else if (planName) {
    crumbs = [
      {
        name: BASIC_CRUMB,
        to: `/${pathParts[0]}`,
      },
      {
        name: `${get(topBarState, `planDate`)} ${get(topBarState, `planName`)}`,
      },
    ]
  }

  setBreadcrumbs(crumbs)
  return null
}

const planTypesCrumbs = (pathParts, setBreadcrumbs, topBarState) => {
  const BASIC_CRUMB = `ТИПЫ ПЛАНОВ`
  // pathParts[0] -> plan-types
  // pathParts[1] -> plan-typesId
  const planTypeName = get(topBarState, `planTypeName`)
  const inModalButNoData = Object.keys(topBarState).length > 0 && !planTypeName
  let crumbs = inModalButNoData
    ? []
    : [
        {
          name: BASIC_CRUMB,
        },
      ]

  if (pathParts[1] === NEW) {
    crumbs = [
      {
        name: BASIC_CRUMB,
        to: `/${pathParts[0]}`,
      },
      { name: `НОВЫЙ ТИП ПЛАНА` },
    ]
  } else if (planTypeName) {
    crumbs = [
      {
        name: BASIC_CRUMB,
        to: `/${pathParts[0]}`,
      },
      { name: planTypeName },
    ]
  }

  setBreadcrumbs(crumbs)
}

const eventsCrumbs = (pathParts, setBreadcrumbs, topBarState) => {
  const BASIC_CRUMB = `СОБЫТИЯ`
  // pathParts[0] -> events
  // pathParts[1] -> eventsId
  const eventName = get(topBarState, `eventName`)
  const inModalButNoData = Object.keys(topBarState).length > 0 && !eventName
  let crumbs = inModalButNoData
    ? []
    : [
        {
          name: BASIC_CRUMB,
        },
      ]

  if (pathParts[1] === NEW) {
    crumbs = [
      {
        name: BASIC_CRUMB,
        to: `/${pathParts[0]}`,
      },
      { name: `НОВОЕ СОБЫТИЕ` },
    ]
  } else if (!topBarState.eventDate && eventName) {
    crumbs = [
      {
        name: BASIC_CRUMB,
      },
    ]
  } else if (eventName) {
    crumbs = [
      {
        name: BASIC_CRUMB,
        to: `/${pathParts[0]}`,
      },
      {
        name: `${get(topBarState, `eventDate`)} ${eventName}`,
      },
    ]
  }

  setBreadcrumbs(crumbs)
}

const eventTypesCrumbs = (pathParts, setBreadcrumbs) => {
  // pathParts[0] -> event-types
  setBreadcrumbs([
    {
      name: `ТИПЫ СОБЫТИЙ`,
    },
  ])
}

const resourcesCrumbs = (pathParts, setBreadcrumbs) => {
  // pathParts[0] -> resources
  setBreadcrumbs([
    {
      name: `РЕСУРСЫ`,
    },
  ])
}

const resourceTypesCrumbs = (pathParts, setBreadcrumbs, topBarState) => {
  const BASIC_CRUMB = `ТИПЫ РЕСУРСОВ`
  // pathParts[0] -> resource-types
  // pathParts[1] -> resource-typesId
  const resourceTypeName = get(topBarState, `resourceTypeName`)
  const inModalButNoData =
    Object.keys(topBarState).length > 0 && !resourceTypeName
  let crumbs = inModalButNoData
    ? []
    : [
        {
          name: BASIC_CRUMB,
        },
      ]

  if (pathParts[1] === NEW) {
    crumbs = [
      {
        name: BASIC_CRUMB,
        to: `/${pathParts[0]}`,
      },
      { name: `НОВЫЙ ТИП РЕСУРСА` },
    ]
  } else if (resourceTypeName) {
    crumbs = [
      {
        name: BASIC_CRUMB,
        to: `/${pathParts[0]}`,
      },
      { name: resourceTypeName },
    ]
  }

  setBreadcrumbs(crumbs)
}
const reportTemplatesCrumbs = (pathParts, setBreadcrumbs) => {
  // pathParts[0] -> report-templates
  // pathParts[1] -> report-templatesId
  if (pathParts.length === 1) {
    setBreadcrumbs([
      {
        name: `ШАБЛОНЫ`,
      },
    ])
  } else {
    const isNew = pathParts[1] === NEW
    setBreadcrumbs([
      {
        name: `ШАБЛОНЫ`,
        to: `/${pathParts[0]}`,
      },
      {
        name: isNew ? `НОВЫЙ ШАБЛОН` : pathParts[1],
      },
    ])
  }
}
const rolesCrumbs = (pathParts, setBreadcrumbs) => {
  // pathParts[0] -> roles
  setBreadcrumbs([
    {
      name: `РОЛИ`,
    },
  ])
}

export const getBreadCrumbs = (
  pathname,
  setBreadcrumbs,
  topBarState,
  planEventCaseName,
) => {
  const pathParts = pathname.split(`/`).slice(1)
  switch (pathParts[0]) {
    case CALENDAR_URL.replace(`/`, ``):
      return calendarCrumbs(pathParts, setBreadcrumbs, topBarState)
    case PLANS_URL.replace(`/`, ``):
      return plansCrumbs(
        pathParts,
        setBreadcrumbs,
        topBarState,
        planEventCaseName,
      )
    case PLAN_TYPES_URL.replace(`/`, ``):
      return planTypesCrumbs(pathParts, setBreadcrumbs, topBarState)
    case EVENTS_URL.replace(`/`, ``):
      return eventsCrumbs(pathParts, setBreadcrumbs, topBarState)
    case EVENT_TYPES_URL.replace(`/`, ``):
      return eventTypesCrumbs(pathParts, setBreadcrumbs)
    case RESOURCES_URL.replace(`/`, ``):
      return resourcesCrumbs(pathParts, setBreadcrumbs)
    case RESOURCE_TYPES_URL.replace(`/`, ``):
      return resourceTypesCrumbs(pathParts, setBreadcrumbs, topBarState)
    case REPORT_TEMPLATES_URL.replace(`/`, ``):
      return reportTemplatesCrumbs(pathParts, setBreadcrumbs)
    case ROLES_URL.replace(`/`, ``):
      return rolesCrumbs(pathParts, setBreadcrumbs)
    default:
      return null
  }
}

// Метод для забора информации из стора для хлебных крошек.
export const getNamesFromState = (state, pathname) => {
  const crumbNames = {}
  const basicName = pathname.split(`/`, 2).join(``)
  const pathParts = pathname.split(`/`).slice(1)
  switch (basicName) {
    case `calendar`:
      if (
        includes(pathParts, EVENTS_URL.replace(`/`, ``)) &&
        pathParts[4] !== NEW
      ) {
        crumbNames.eventName = get(
          selectData(state, eventModel, pathParts[4]),
          `name`,
          ``,
        )
        crumbNames.eventDate = `${getDate(
          get(selectData(state, eventModel, pathParts[4]), `startDateTime`),
        )} - ${getDate(
          get(selectData(state, eventModel, pathParts[4]), `endDateTime`),
        )}`
      }
      break
    case `plans`:
      if (pathParts.length > 1) {
        crumbNames.planName = get(
          selectData(state, planModel, pathParts[1]),
          `name`,
          ``,
        )
        crumbNames.planDate = `${getDate(
          get(selectData(state, planModel, pathParts[1]), `startDateTime`),
        )} - ${getDate(
          get(selectData(state, planModel, pathParts[1]), `endDateTime`),
        )}`
      }
      if (includes(pathParts, `calendar`)) {
        if (
          includes(pathParts, EVENTS_URL.replace(`/`, ``)) &&
          pathParts[6] !== NEW
        ) {
          crumbNames.eventName = get(
            selectData(state, eventModel, pathParts[6]),
            `name`,
            ``,
          )
          crumbNames.eventDate = `${getDate(
            get(selectData(state, eventModel, pathParts[4]), `startDateTime`),
          )} - ${getDate(
            get(selectData(state, eventModel, pathParts[4]), `endDateTime`),
          )}`
        }
      }
      break
    case `resource-types`:
      if (pathParts.length > 1) {
        crumbNames.resourceTypeName = get(
          selectData(state, resourceTypeModel, pathParts[1]),
          `name`,
          ``,
        )
      }
      break
    case `plan-types`:
      if (pathParts.length > 1) {
        crumbNames.planTypeName = get(
          selectData(state, planTypeModel, pathParts[1]),
          `name`,
          ``,
        )
      }
      break
    case `events`:
      if (pathParts.length > 1) {
        const eventData = selectData(state, eventModel, pathParts[1])
        crumbNames.eventName = get(
          selectData(state, eventModel, pathParts[1]),
          `name`,
          ``,
        )
        crumbNames.eventDate =
          eventData !== null
            ? `${getDate(
                get(
                  selectData(state, eventModel, pathParts[4]),
                  `startDateTime`,
                ),
              )} - ${getDate(
                get(selectData(state, eventModel, pathParts[4]), `endDateTime`),
              )}`
            : ``
      }
      break
    default:
      break
  }
  return { topBarState: crumbNames }
}
